import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import MotorFetcherFactory from '../../fetcher/Fetchers/factory.js'
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {HttpUserDiscardedAdsRepository} from '../Repositories/HttpUserDiscardedAdsRepository.js'

class GetUserDiscardedAdsUseCase extends UseCase {
  #getCurrentUserService
  #repository
  #userNotLoggedInError

  static create({config}) {
    return new GetUserDiscardedAdsUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      repository: HttpUserDiscardedAdsRepository.create({
        config,
        authenticationFetcher: MotorFetcherFactory.httpAuthenticationFetcher({config})
      }),
      userNotLoggedInError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  constructor({getCurrentUserService, repository, userNotLoggedInError}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
    this.#userNotLoggedInError = userNotLoggedInError
  }

  @tracer({metric: 'GetUserDiscardedAdsUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInError({message: '[GetUserDiscardedAdsUseCase#execute] User is not logged in'}).toJSON()
      )

    const userId = userEntity.getId()
    const discardedAdsValueObject = await this.#repository.getDiscardedAds({userId})

    return discardedAdsValueObject.toJSON()
  }
}

export const factory = GetUserDiscardedAdsUseCase.create
